export default "__VITE_ASSET__CMYBhjsj__"